'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * SalesforceChatEmbed
     *
     * This web component will add JS scripts to a page for Salesforce Livechat.
     * The script only needs to to be added to the page to render the chat.
     * All chat functionality is handled by Salesforce.
     *
     * @example
     *   <phoenix-salesforce-chat-embed />`;
     */
    class PhoenixSalesforceChatEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            if (this.config?.baseSite && this.config?.liveAgentSite && this.config?.siteCode) {
                const baseScript = pageClass.util.addScriptResourceOnce(
                    'https://service.force.com/embeddedservice/5.0/esw.min.js'
                );
                baseScript.then(() => {
                    if (!window.embedded_svc) {
                        const siteScript = pageClass.util.addScriptResourceOnce(
                            `https://${this.config?.baseSite}.my.salesforce.com/embeddedservice/5.0/esw.min.js`
                        );
                        siteScript.then(() => {
                            this.initESW(null);
                        });
                    } else {
                        this.initESW('https://service.force.com');
                    }
                });
            }
        }

        initESW(gslbBaseURL, embedded_svc = window.embedded_svc || {}) {
            embedded_svc.settings = {
                ...(embedded_svc.settings || {}),
                displayHelpButton: true,
                language: '',
                enabledFeatures: ['LiveAgent'],
                entryFeature: 'LiveAgent',
            };

            embedded_svc?.init(
                `https://${this.config?.baseSite}.my.salesforce.com`,
                `https://${this.config?.liveAgentSite}.my.salesforce-sites.com/liveagent`,
                gslbBaseURL,
                this.config?.siteCode,
                'Customer_Service_Support_SnapIn',
                {
                    baseLiveAgentContentURL: 'https://c.la3-c2-ia7.salesforceliveagent.com/content',
                    deploymentId: '5721I000000Yu9i',
                    buttonId: '5731I000000Yq5r',
                    baseLiveAgentURL: 'https://d.la3-c2-ia7.salesforceliveagent.com/chat',
                    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I1I000000XbaSUAS_1692a511134',
                    isOfflineSupportEnabled: true,
                }
            );
        }
    }
    window.customElements.define('phoenix-salesforce-chat-embed', PhoenixSalesforceChatEmbed);
});
